import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'NiboCurrency' })
export class CurrencyValuePipe implements PipeTransform {
  transform(value: number | string): string {
    if (value) {
      if (typeof value === 'string') {
        value = parseFloat(value);
      }

      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    return null;
  }
}
